<template>
  <b-media tag="li">
    <template v-slot:aside>
      <span class="bg-gray pt-3 pl-3 media-wrapper">
        <font-awesome-icon class="text-white align-middle" icon="book-open" size="2x"></font-awesome-icon>
      </span>
    </template>
    <h5 class="mt-0 mb-3 text-left">
      <router-link :to="{ name: 'recipeView', params: { id:recipe.id }}">{{ recipe.title }}</router-link>
    </h5>
    <p class="mb-0 text-left">
      <span class="text-justify">{{ recipe.description }}</span>
    </p>
  </b-media>
</template>

<script>
export default {
  name: 'RecipeMedia',
  props: {
    recipe: Object
  }
}
</script>

<style scoped>
.media-wrapper {
  width: 64px;
  height: 64px
}
</style>



// WEBPACK FOOTER //
// src/components/recipes/RecipeMedia.vue